export default {
  "HitPaw Online Audio Converter": "HitPaw Online Audio Converter",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.",
  'HitPaw Online Image Converter': 'HitPaw Online Image Converter',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'Convert images to JPG, PNG, BMP, TIFF and more formats for free.',
  'HitPaw Online Video Converter': 'HitPaw Online Video Converter',
  'Convert videos to any formats as your requirements.': 'Convert videos to any formats as your requirements.',
  'Add More Files': 'Add More Files',
  'Convert to': 'Convert to',
  'Ready': 'Ready',
  'Converting': 'Converting',
  'Video': 'Video',
  'Audio': 'Audio',
  'Image': 'Image',
  'Retry': 'Retry',
  'Download All': 'Download All',
  'Download Desktop': 'Download Desktop',
  'Continue Editing': 'Continue Editing',
  'Convert': 'Convert',
  'Cut': 'Cut',
  'Speed': 'Speed',
  'Crop & Rotate': 'Crop & Rotate',
  'Resize': 'Resize',
  'Extract': 'Extract',
  'Add Music': 'Add Music',
  'Subtitles': 'Subtitles',
  'Merge': 'Merge',
  'Watermark Remover': 'Watermark Remover',
  'Add Watermark': 'Add Watermark',
  'Batch Processing': 'Batch Processing',
};
